import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Client } from './client';

@Injectable()
export class ServiceTaxiService {
  constructor ( private http: HttpClient,
                private client: Client ) { }

  getService (): Observable<any> {
    return this.http.get( this.client.getServicesUrl() );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/service-taxi.service.ts